import regions from "./checker-addresses.json" with { type: "json" };

/**
 * Where Spectate's uptime checks come from, for the IP addresses page and
 * `/ip-addresses.txt` (written at build time by `scripts/postprocess-build.mjs`).
 * The addresses are a copy of `laravel/resources/data/checker-addresses.json`
 * (`npm run sync:openapi`), which `GET /v1/checker-addresses` also serves. Keep that
 * file in line with the checker servers (docs/go-live.md, "Where it runs") and
 * marketing's acceptable use policy.
 */
export type CheckerRegion = {
  /** The monitor location value in the API and dashboard. */
  location: string;
  name: string;
  ipv4: string[];
  ipv6: string[];
};

export const checkerUserAgent = "Spectate/1.0 (+https://docs.spectate.net/faq/uptime-monitor-bot)";

export const checkerRegions: CheckerRegion[] = regions;

export const ipAddressesText = (): string =>
  checkerRegions
    .map((region) => [`# ${region.name}`, ...region.ipv4, ...region.ipv6].join("\n"))
    .join("\n\n") + "\n";
